import type {ReactAction} from '@netx/core/bootstrap';
import {faShare} from '@netx/core-icons';
import {type ICategory} from '@netx/core-category-next/schema';
import {canShareCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';
import {categoryActionShareLink} from './category-share-link';

export const categoryActionShareMenuIcon = faShare;

/**
 * Share category
 * @param params
 * @returns Action
 */
export const categoryActionShareMenu = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-share-menu',
	cb: () => {}, //dispatcher.trigger(CATEGORY_EVENT.MENU, category),
	enableTest: () => canShareCategory(category),
	icon: categoryActionShareMenuIcon,
	get label() {
		return CategoryActionLabel.MENU;
	},
	children: [categoryActionShareLink(category)],
	...params,
});

export default categoryActionShareMenu;
